import { ClientId, useConfig } from '@nexelem/config';
import { useCustomTranslation } from '../../../../../hooks';
import { cn } from '@nexelem/utils';
import { Avatar, Badge, IconButton, Status } from '@nexelem/components';
import { ChevronLeftRounded } from '@mui/icons-material';
import { ResourceAvailabilityMeta, ResourceAvailabilityMetaValue } from '@nexelem/graphne-api';

export type WorkerAvatarProps = {
  data: ResourceAvailabilityMeta;
  isOpen: boolean;
  setOpen: () => void;
};

export const WorkerAvatar = ({ data, setOpen, isOpen }: WorkerAvatarProps) => {
  const { tWrapper } = useCustomTranslation('products.productionPlan');
  const { clientId } = useConfig();

  const { name, capabilities, externalName } = data.resource;
  const availability = data.value;
  const [firstName, ...rest] = name.split(' ');
  const lastName = rest.join(' ');

  const displayCompetences =
    clientId === ClientId.sanok ? capabilities?.filter((cmp) => cmp.groupName === 'stanowisko') : capabilities;

  return (
    <>
      <Avatar firstName={firstName} lastName={lastName} size="large" />
      <div className="flex flex-col gap-1">
        {externalName && (
          <span className="text-s11-sb text-text-secondary">
            {tWrapper('workerId', { id: externalName.toUpperCase() })}
          </span>
        )}
        <div className="flex flex-wrap items-center gap-2">
          <span className="text-s16-sb">
            {firstName} {lastName}
          </span>
          {displayCompetences?.map(({ id, name }) => <Badge key={id}>{name}</Badge>)}
          {availability === ResourceAvailabilityMetaValue.Available && (
            <Status color="green" showDot={false} text={tWrapper('available')} variant="outlined" />
          )}
          {availability === ResourceAvailabilityMetaValue.Unavailable && (
            <Status color="red" showDot={false} text={tWrapper('unavailable')} variant="outlined" />
          )}
          {availability === ResourceAvailabilityMetaValue.PartiallyAvailable && (
            <Status color="orange" showDot={false} text={tWrapper('partiallyAvailable')} variant="outlined" />
          )}
        </div>

        {/* TODO: Add Availability % */}
        {/* <Status color="orange" showDot={false} text="Dostepność 0%" variant="outlined" /> */}
      </div>
      <IconButton
        className={cn('ml-auto shrink-0 -rotate-90 transition-transform', isOpen && 'rotate-90')}
        Icon={ChevronLeftRounded}
        onClick={setOpen}
      />
    </>
  );
};
